import { createApp } from 'vue';
import ConfirmModal from '../components/confirm.vue';
export default {
    install(app) {
        app.config.globalProperties.$confirm = (text, header = '확인') => {
            return new Promise((resolve) => {
                const container = document.createElement('div');
                document.body.appendChild(container);

                const modalApp = createApp(ConfirmModal, {
                    text,
                    header,
                    resolve,
                });

                modalApp.mount(container);
            });
        };
    },
};
